import get from 'lodash/get'
import isEqual from 'lodash/isEqual'
import React, { useRef } from 'react'
import { useTranslate } from 'react-translate'
import { Field, Form, FormSection } from 'redux-form'
import styled from 'styled-components/macro'

import DataTable from '../../../DataTable'
import DateLocationFormat from '../../../DateLocationFormat'
import { DRIVER_TYPES } from '../../schedule-updates.constants'
import DataNameField from '../DataNameField'
import DataSelection from '../DataSelection'
import DataLabel from '../ImagesTable/DataLabel'

const DataTableContainer = styled.div`
  width: 100%;
  height: ${props => props.compact ? 'calc(100% - 3rem)' : '100%'};
`

const StyledForm = styled(Form)`
  width: 100%;
  height: 100%;
`

const FontsTable = ({
  handleSubmit,
  data,
  submit,
  updatesSelectAssets,
  onSubmit,
  compact,
  onSchedule,
  isValidTime,
  valid
}) => {
  const t = useTranslate('ScheduleUpdateModal')
  const assetList = useRef([])

  const handleSelectionChange = selectedAssets => {
    if (!isEqual(selectedAssets, assetList.current)) {
      assetList.current = selectedAssets
      updatesSelectAssets(selectedAssets)
    }
  }

  return (
    <StyledForm
      onSubmit={
        handleSubmit(form => {
          onSubmit(assetList.current.map(
            a => {
              return {
                ...a,
                form: form.deviceList[a.id]
              }
            }
          ))
        })
      }
    >
      <DataTableContainer compact={compact}>
        <FormSection name='deviceList'>
          <DataTable
            search
            data={data}
            selection
            selectionMode='single'
            totalRows={data.length}
            rows={data.length}
            rowHeight={40}
            generateFilters
            onSelectionChange={handleSelectionChange}
          >
            <DataTable.ActionBar>
              {isValidTime && valid &&
                <DataTable.ActionBar.Item
                  content={t('Update')}
                  onClick={submit}
                />
              }
            </DataTable.ActionBar>
            <DataTable.Column
              label={t('Update Name')}
              dataKey='name'
              width={0.65}
              flexShrink={0.65}
              flexGrow={0.65}
              cellRenderer={props =>
                <DataNameField {...props} />
              }
            />
            <DataTable.Column
              label={t('Version')}
              dataKey='version'
              cellRenderer={({ cellData }) => {
                return cellData || t('Not applicable')
              }}
              width={0.2}
              flexShrink={0.2}
              flexGrow={0.2}
            />
            <DataTable.Column
              label={t('File size')}
              dataKey='fileSize'
              width={0.25}
              flexShrink={0.25}
              flexGrow={0.25}
            />
            <DataTable.Column
              label={t('Release date')}
              dataKey='releaseDate'
              width={0.5}
              flexShrink={0.5}
              flexGrow={0.5}
              cellRenderer={props =>
                <DateLocationFormat
                  {...props}
                  field='releaseDate'
                />
              }
            />
            <DataTable.Column
              label={t('Drive')}
              dataKey='drive'
              width={0.7}
              flexShrink={0.7}
              flexGrow={0.7}
              cellRenderer={props => {
                return (
                  <DataSelection
                    {...props}
                    id={props.rowData.id}
                    options={DRIVER_TYPES}
                  />
                )
              }}
            />
            <DataTable.Column
              label={t('Font id')}
              dataKey='fontId'
              width={0.25}
              flexShrink={0.25}
              flexGrow={0.25}
              cellRenderer={props => {
                return (
                  <DataSelection
                    {...props}
                    id={props.rowData.id}
                    options={props.rowData.fontsDrive}
                  />
                )
              }}
            />
            <DataTable.Column
              label={t('Label')}
              dataKey='label'
              width={0.7}
              flexShrink={0.7}
              flexGrow={0.7}
              cellRenderer={props => {
                const fileType = get(props, 'rowData.type', '')
                const placeholder = fileType === 'DEVCONFIG-font/ttf' ? t('Required label') : t('No required label')
                return (
                  <DataLabel
                    {...props}
                    id={props.rowData.id}
                    placeholder={placeholder}
                  />
                )
              }}
            />
          </DataTable>
        </FormSection>
      </DataTableContainer>
    </StyledForm>
  )
}

FontsTable.defaultProps = {
  data: []
}

export default FontsTable
